import { CheckboxDesignTokens } from '@primeuix/themes/aura/checkbox';

export const checkboxTokens: CheckboxDesignTokens = {
  root: {
    borderRadius: '{border.radius.sm}',
    borderColor: '{form.field.border.color}',
    width: '1.25rem',
    height: '1.25rem',
    background: '{form.field.background}',
    checkedBackground: '{primary.color}',
    checkedHoverBackground: '{primary.hover.color}',
    checkedHoverBorderColor: '{primary.hover.color}',
    checkedBorderColor: '{primary.color}',
    checkedFocusBorderColor: '{primary.color}',
    checkedDisabledBorderColor: '{form.field.border.color}',
    disabledBackground: '{form.field.disabled.background}',
    filledBackground: '{form.field.filled.background}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.border.color}',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: '{focus.ring.shadow}',
    },
    invalidBorderColor: '{form.field.invalid.border.color}',
    shadow: '{form.field.shadow}',
    sm: {
      width: '1rem',
      height: '1rem',
    },
    lg: {
      width: '1.5rem',
      height: '1.5rem',
    },
    transitionDuration: '{form.field.transition.duration}',
  },
  icon: {
    size: '0.875rem',
    color: '{form.field.color}',
    checkedColor: '{primary.contrast.color}',
    checkedHoverColor: '{primary.contrast.color}',
    disabledColor: '{form.field.disabled.color}',
    sm: {
      size: '0.75rem',
    },
    lg: {
      size: '1rem',
    },
  },
};
